import * as React from "react";

import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import { Navigate, useRoutes } from "react-router-dom";
import ScrollToTop from "./component/common/ScrollToTop";
import Header from "pages/header/Header";
import Footer from "pages/footer/Footer";
const PrivacyPolicy = React.lazy(() =>
  import("pages/privacy-policy/PrivacyPolicy")
);
const TermsOfService = React.lazy(() =>
  import("pages/terms-of-service/TermsOfService")
);
const WhyNarad = React.lazy(() => import("pages/why-lusoft/WhyLusoft"));
const LandingPage = React.lazy(() => import("pages/landing-page/LandingPage"));

export default function AppRouting() {
  const defaultNavigate = <Navigate to={"/"} />;

  const getRouteWrapper = ({ component, hideHeaderFooter }) => {
    return (
      <>
        {!hideHeaderFooter ? <Header /> : null}
        <React.Suspense
          fallback={
            <Box
              width="100%"
              height="100vh"
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <CircularProgress />
            </Box>
          }
        >
          <Box
            sx={{
              marginTop: {
                xs: hideHeaderFooter ? 0 : "90px",
                sm: hideHeaderFooter ? 0 : "100px",
              },
            }}
          >
            {component}
          </Box>
        </React.Suspense>
        {!hideHeaderFooter ? <Footer /> : null}
      </>
    );
  };

  const routes = [
    {
      path: "/",
      element: getRouteWrapper({
        component: <LandingPage />,
      }),
    },
    {
      path: "/our-story",
      element: getRouteWrapper({
        component: <WhyNarad />,
      }),
    },
    {
      path: "/privacy-policy",
      element: getRouteWrapper({
        component: <PrivacyPolicy />,
      }),
    },
    {
      path: "/terms-of-service",
      element: getRouteWrapper({
        component: <TermsOfService />,
      }),
    },
    {
      path: "*",
      element: defaultNavigate,
    },
  ];
  const routing = useRoutes(routes);
  return (
    <>
      <ScrollToTop />
      {routing}
    </>
  );
}
